import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '../form/form.service';
import { ParserService } from '../services/parser.service';
import { PreParserService } from '../services/pre-parser.service';
import { ValidationService, ValidationType } from '../services/validation.service';
import { PageConfig } from '../models/page.interface';
import { PageComponent } from "../page/page.component";
import { RFFConstants } from '../constants';
import { CustomMessageComponent } from '../../custom-message/custom-message.component';
@Component({
  selector: 'app-sub-form',
  templateUrl: './sub-form.component.html',
  styleUrls: ['./sub-form.component.scss']
})
export class SubFormComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
    private _router: Router,
    private _formService: FormService,
    private _parseService: ParserService,
    private _preParserService: PreParserService,
    private _validationService: ValidationService,
    private constants: RFFConstants
  ) { }

  @ViewChild(PageComponent) form: PageComponent;

  formId = '';
  data = {};
  template = {
    "category": "",
    "displayFields": [],
    "name": "",
    "rFFSchema": {}
  };
  subFormPreview = false;
  isEditable: boolean;
  pages: PageConfig[] = [];
  showLoading: boolean = false;


  ngOnInit() {
    if (this.formId.length !== 0) {
      this._formService.getForm(this.formId)
        .subscribe(
          (result: any) => {

            this.template = result.data.templateDetails;

            this.generateFormView();
            this.subFormPreview = true;
          },
          (err) => {
            console.log(err);
          });
    } else {
      this.generateFormView();
    }


    //Subscribing to ValidationService for Applyling Validation
    this.validationApplier();
  }

  generateFormView() {

    if (Object.keys(this.template.rFFSchema).length === 0) {

      return;
    }
    const prefillContent = this._preParserService.parseForPrefillContent(this.template.rFFSchema)

    if (Object.keys(prefillContent).length > 0) {

      //Fetching Prefill Query data
      var prefillQueryData = this.fetchPrefillQueryContent(prefillContent);

      const queryData = prefillQueryData.queryData;
      const data = prefillQueryData.data;
      if (Object.keys(queryData).length > 0) {

        //Fetching Prefill Input data
        const self = this;
        this.fetchPrefillInputData(data, queryData, function (inputData) {
          self.data = Object.assign(data, self.data);

          self._formService.getAssets()
            .subscribe(
              (result: any) => {
                if (result.data) {

                  var customData = {};
                  _.forEach(result.data, (value, key) => {
                    var optionsData = [];
                    _.forEach(value, (asset) => {

                      let option = {};
                      option[asset['_id']] = asset['name'];
                      optionsData.push(option);
                    });
                    customData[key] = optionsData;
                  })

                  self.pages = self._parseService.parseForm(self.template.rFFSchema, { data: self.data, error: {} }, inputData, customData);
                } else {
                  self.pages = self._parseService.parseForm(self.template.rFFSchema, { data: self.data, error: {} }, inputData);
                }
              },
              err => {
                console.log(err);
              }
            );
          self.validateFields(self.data);
        });
      } else {
        this.data = Object.assign(data, this.data);
        this.pages = this._parseService.parseForm(this.template.rFFSchema, { data: this.data, error: {} });
        this.validateFields(this.data);
      }
    } else {
      if (Object.keys(this.data).length > 0) {
        this.pages = this._parseService.parseForm(this.template.rFFSchema, { data: this.data, error: {} });
        this.validateFields(this.data);
      } else {
        this.pages = this._parseService.parseForm(this.template.rFFSchema);
      }
    }
  }

  validateFields(data) {

    if (this.pages.length > 0) {
      _.forEach(this.pages[0].sections, (section) => {
        section.style.editability = false;
        _.forEach(section.fields, (field) => {
          this._validationService.applyValidation(field, data, [ValidationType.onChange]);
          field.style.editability = this.isEditable;
        });
      });
    }
  }

  submit() {
    var data = {};
    var errors = {};

    const templateId = this.formId;
    const formData = {};

    _.forEach(this.pages[0].sections, (section) => {
      if (section.value) {
        data[section.id] = section.value;
      }
      _.forEach(section.fields, (field) => {
        if (field.value) {

          data[field.id] = field.value;
        }
        this._validationService.applyValidation(field, data, [ValidationType.isRequired, ValidationType.onChange]);
        if (field.errorMessage && field.style.visibility === true) {
          errors[field.id] = field.errorMessage;
        }
      });
    });

    if (Object.keys(errors).length > 0) {
      this.showErrorAlert('Information!!', 'Please fill all the mandatory fields', ['Ok']);
      return;
    }

    formData['data'] = data;
    formData['template'] = { _id: templateId, name: this.template.name, displayFields: this.template.displayFields, category: this.template.category };

    this.activeModal.close(formData);
  }

  validationApplier() {
    this._validationService.behaviourData.subscribe(behaviourData => {

      if (behaviourData && Object.keys(behaviourData).length > 0 && this.pages[0]) {

        _.forEach(this.pages[0].sections, (section) => {

          //Updating behaviour data to models
          _.forEach(section.fields, (field) => {

            if (behaviourData['data'] && behaviourData['data'][field.id]) {

              const value = behaviourData['data'][field.id];
              field.value = value;
            }

            if (behaviourData['visibility'] && behaviourData['visibility'][field.id] !== undefined) {

              const value = behaviourData['visibility'][field.id];
              field.style.visibility = value;
            }

            if (behaviourData['editability'] && behaviourData['editability'][field.id] !== undefined) {

              const value = behaviourData['editability'][field.id];
              field.style.editability = value;
            }

            if (behaviourData['options'] && behaviourData['options'][field.id] !== undefined) {

              const options = behaviourData['options'][field.id];
              field.data = options;
            }

            if (behaviourData['background_color'] && behaviourData['background_color'][field.id] !== undefined) {

              const value = behaviourData['background_color'][field.id];
              field.style.background_color = value;
            }
            if (behaviourData['border_color'] && behaviourData['border_color'][field.id] !== undefined) {

              const value = behaviourData['border_color'][field.id];
              field.style.border_color = value;
            }
            if (behaviourData['border_thickness'] && behaviourData['border_thickness'][field.id] !== undefined) {

              const value = behaviourData['border_thickness'][field.id];
              field.style.border_thickness = value;
            }
            if (behaviourData['corner_radius'] && behaviourData['corner_radius'][field.id] !== undefined) {

              const value = behaviourData['corner_radius'][field.id];
              field.style.corner_radius = value;
            }

            if (this.form) {
              this.form.pageGroup.get(field.id).setValue(field.value);
            }

          })
        })
      }
    });
  }

  fetchPrefillQueryContent(prefillContent) {
    var data = {};
    var queryData = {};
    _.forIn(prefillContent, (fieldProps, fieldKey) => {
      //Applying prefill data
      if (fieldProps['default'] && fieldProps['default']['type']) {
        if (fieldProps['default']['type'] === 'custom') {
          data[fieldKey] = fieldProps['default']['value'];
        } else {
          const type: string = fieldProps['default']['type'];
          if (fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.ShortText || fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.LongText) {
            const query = type.split(':');
            var value = '';
            if (query[0] === '_fh_user') {
              value = localStorage.getItem('userName');
            } else if (query[0] === '_fh_team') {
              value = localStorage.getItem('teamName');
            }
            data[fieldKey] = value;
          } else if (fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.MultiChoiceList || fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.CheckBoxList) {
            const query = type.split('$$');

            queryData[fieldKey] = this.fetchPrefillContent(query);
          } else if (fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.UserList) {
            const query = type.split(':');

            query.push('team._id::' + localStorage.getItem('teamId'));
            queryData[fieldKey] = this.fetchPrefillContent(query);
          }
        }
      };
    });

    return { queryData, data };
  }

  fetchPrefillInputData(data, queryData, callback) {
    var inputData = {};
    this.showLoading = true;
    _.forIn(queryData, (queryDataObj, fieldKey) => {
      this._formService.query(queryDataObj)
        .subscribe(
          (result: any) => {
            this.showLoading = false;
            console.log(result);
            var prefillContent = [];

            if (queryDataObj['type'] === '_fh_team_user_list') {
              result.data = result.data[0] ? result.data[0].users : [];
              _.map(result.data, (item) => {
                var finalItem = {};
                finalItem[item._id] = item.name;
                prefillContent.push(finalItem);
              })
            } else {

              _.map(result.data, (item) => {
                var finalItem = {};
                finalItem[item._id] = item[queryDataObj['attribute']];
                prefillContent.push(finalItem);
              })
            }

            inputData[fieldKey] = prefillContent;

            if (Object.keys(queryData).length === Object.keys(inputData).length) {

              return callback(inputData);
            }
          },
          (err) => {
            this.showLoading = false;
            console.log(err);
          });
    });
  }

  fetchPrefillContent(query: Array<string>) {
    var queryData: any = {};
    _.forEach(query, (element, index) => {
      const queryParams = ['type', 'attribute']
      if ((index === 0) || (index === 1)) {
        queryData[queryParams[index]] = element;
      } else {
        if (!queryData.filters) {
          queryData.filters = {};
        }
        const filters = element.split('::');
        queryData.filters[filters[0]] = filters[1];
      }
    });

    return queryData;
  }

  showErrorAlert(title: string, message: string, actions: any) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-small nested-modal',
    };
    const modalRef = this.modalService.open(
      CustomMessageComponent,
      modalOptions
    );

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.actions = actions;
  }
  getBase64String(str) {
    return 'data:image/jpg;base64,' + str;
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/sub-form/sub-form.component.ts